<template>
    <div class="list-container">
        <h2>Manage Phase Determinations</h2>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <table class="nurse-table" v-else>
            <thead>
                <tr>
                    <th>Student PID</th>
                    <th>Student</th>
                    <th>Dose</th>
                    <th>Current Phase</th>
                    <th>Requested Phase</th>
                    <th>Form Date</th>
                    <th style="width: 180px;">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pd in phaseList" :key="pd.id">
                    <td>{{ pd.student?.pid }}</td>
                    <td>{{ pd.student?.user?.name }}</td>
                    <td>{{ pd.dose }}</td>
                    <td>{{ pd.current_phase }}</td>
                    <td>{{ pd.requested_phase }}</td>
                    <td>{{ $formatDate(pd.form_date) }}</td>
                    <td>
                        <button v-if="$canAccess('PractitionerSignaturePhaseDetermination')"
                            class="btn btn-sm btn-outline-primary"
                            @click="$router.push({ name: 'PractitionerSignaturePhaseDetermination', params: { id: pd.id } })">
                            🖊️ Signature
                        </button>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            phaseList: [],
            loading: false,
        };
    },
    methods: {
        async fetchData() {
            this.loading = true;
            try {
                const res = await this.$api.get("/phase-determinations");
                this.phaseList = res.data;
            } catch (err) {
                console.error("Error loading data", err);
            } finally {
                this.loading = false;
            }
        },
        async deleteItem(id) {
            if (!confirm("Delete this phase determination?")) return;
            await this.$api.delete(`/phase-determinations/${id}`);
            this.fetchData();
        }
    },
    mounted() {
        this.fetchData();
    }
};
</script>

<style scoped>
/* @import '../nurses/NurseList.vue'; */
/* If styles shared */

.list-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.nurse-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.nurse-table th,
.nurse-table td {
    padding: 10px;
    border: 1px solid #ddd;
}

.nurse-table th {
    background: #f4f4f4;
}

.edit-btn {
    background-color: #ffc107;
    color: black;
}

.btn-danger {
    background-color: #dc3545;
    color: white;
}
</style>